import { AssemblyRow } from 'model/Project/BoMItemRow'
import { BoMItemSatisfyActiveFilters } from 'utils/BoMItemSatisfyActiveFilters'
import { ProjectState } from '../../../../store/Project/ProjectTypes'

export const updateTreeViewFilteredPartsAndSubassemblies = (
  state: ProjectState
) => {
  if (!state.treeView) {
    return state
  }

  const assemblyVisible = (assemblyId: string): boolean => {
    const assembly = state.treeView[assemblyId] as AssemblyRow

    let visible = false
    const filteredSubAssembliesIds = []
    const filteredPartTypeIds = []

    if (assembly.subAssembliesIds?.length) {
      assembly.subAssembliesIds.forEach((subAssemblyId) => {
        if (subAssemblyId) {
          visible = visible || assemblyVisible(subAssemblyId)
          if (visible) {
            filteredSubAssembliesIds.push(subAssemblyId)
            visible = true
          }
        }
      })
    }

    if (assembly.partTypeIds?.length) {
      assembly.partTypeIds.forEach((partTypeId) => {
        if (
          BoMItemSatisfyActiveFilters(state.filters, state.treeView[partTypeId])
        ) {
          filteredPartTypeIds.push(partTypeId)
          visible = true
        }
      })
    }

    assembly.filteredSubAssembliesIds = filteredSubAssembliesIds
    assembly.filteredPartTypeIds = filteredPartTypeIds

    visible = visible || BoMItemSatisfyActiveFilters(state.filters, assembly)

    return visible
  }

  const allAssemblies = Object.values(state.treeView).filter(
    (bomItem) => bomItem.type === 'Assembly'
  ) as AssemblyRow[]

  allAssemblies.forEach((assembly) => {
    const visible = assemblyVisible(assembly.id)

    if (!visible && assembly.parentId !== null) {
      const parentAssembly = state.treeView[assembly.parentId] as AssemblyRow

      parentAssembly.filteredSubAssembliesIds =
        parentAssembly.filteredSubAssembliesIds.filter((x) => x !== assembly.id)
    }
  })

  return state
}

export const updateHeadersFilteredParts = (state: ProjectState) => {
  if (!state.flatView) {
    return state
  }

  const headers = Object.values(state.flatView).filter(
    (x) =>
      x.type === 'AssemblyHeader' ||
      x.type === 'MaterialHeader' ||
      x.type === 'RoutingHeader'
  )
  const activeFilters = state.filters

  headers.forEach((header) => {
    const filteredParts = []

    if (header.type === 'AssemblyHeader') {
      header.assembly.partTypeIds.forEach((partId) => {
        if (
          BoMItemSatisfyActiveFilters(activeFilters, state.flatView[partId])
        ) {
          filteredParts.push(partId)
        }
      })

      header.filteredPartTypeIds = filteredParts
      state.flatView[header.assembly.id] = header
    } else if (
      header.type === 'MaterialHeader' ||
      header.type === 'RoutingHeader'
    ) {
      header.partTypeIds.forEach((partId) => {
        if (
          BoMItemSatisfyActiveFilters(activeFilters, state.flatView[partId])
        ) {
          filteredParts.push(partId)
        }
      })

      header.filteredPartTypeIds = filteredParts
      state.flatView[header.id] = header
    }
  })

  state.selectedBomItemIds = state.selectedBomItemIds?.filter(
    (selectedBomItem) => {
      return BoMItemSatisfyActiveFilters(
        activeFilters,
        state.flatView[selectedBomItem]
      )
    }
  )

  state = updateTreeViewFilteredPartsAndSubassemblies(state)

  return state
}
